export let SurveyData = [
    {
        ID:1,
        type:"introduction",
        title:[`Thank you for signing the MSD Pledge and helping us get one step closer to preventing work-related musculoskeletal disorders (MSDs). You've joined a growing community of companies dedicated to ensuring the health and safety of all their employees!`,   
                `Please complete this Onboarding Questionnaire to help us understand more about your organization's MSD journey. You will get to sample some of the MSD Solutions Index questions, which will be a more in-depth, follow-up survey to the Onboarding Questionnaire, so you can get a sense of what alignment to the pledge may look like.`,
                `This survey should take no more than 10 minutes to complete. Select the "Let's Go!" button below to:`
        ],
        responses:[
            "Review informed consent",
            "Provide basic demographic information",
            "Answer 11 questions about your Environmental, Health, & Safety (EHS) and MSD systems",
            "Click 'submit' Receive instant feedback!"
        ],
        uniqueInput:false,

    },
    {
        ID:2,
        type:"informedConsent",
        title:`Informed Consent`,
        responses:[   
           [ `What is the purpose of this questionnaire?`,`The purpose of this questionnaire is to help us better understand your company's current response to MSDs and injuries in the workplace, measure alignment to the MSD Pledge, and provide you with an early view of the Index's' “look and feel”. The information you provide will be used to ensure your company's and our engaged safety partners' alignment to the Pledge, while measuring current MSD prevention strategies.`],
            [`What are the participation expectations?`,`You are asked to complete an 11-question survey regarding your company's current MSD prevention strategies. This is expected to take you no more than 5 - 10 minutes to finish.`],
            [`Are there any risks to me?`,`There are no risks to you beyond normal use of a computer for the duration of the survey. Questions or concerns should be directed to the MSD Solutions Lab Research Manager.`],
            [`What about confidentiality?`,`All information obtained in this questionnaire will remain confidential; that is only the research team will have access to the raw data and information that could potentially identify you as a participant. However, absolute confidentiality of data provided over the internet cannot be guaranteed due to limited protection of internet access. All data will be kept on a password protected network drive at the National Safety Council only accessible to the MSD Solutions Lab research team. You will be asked to provide your name, email, and company name. In the instance of publishing research associated with the collected data, no personally identifying information will be disclosed and data will only be reported in the aggregate.`],
            [`What are the benefits of participating?`,`You and your organization's participation may help in the development of more effective MSD and injury prevention strategies. There are no direct benefits to you personally; however, participation in this project may increase awareness and knowledge of MSD prevention strategies.`],
            [`What if I want to leave?`,`You have the right to refuse participation and withdraw at any time as your participation is voluntary in the Onboarding Questionnaire. However, measurement of alignment to the pledge is an expectation of signing the MSD Pledge. The MSD Solutions Lab will not be able to accurately measure your progress and alignment to the pledge if you withdraw.`],
            [`Will I get paid for participation? What will my participation cost?`,`Other than time spent completing the questionnaire, there is no cost to you. There is no compensation for completing the questionnaire.`],
            [``,`If you have any other questions, please contact the MSD Solutions Lab Research Manager (paige.debaylo@nsc.org).`],
            [`By clicking "Next" below, I indicate that I have read the above informed consent, understand the terms, and agree to participate in the Onboarding Questionnaire.`]],
        uniqueInput:false,

    },
    {
        ID: 3,
        type: 'radio',
        title: "I am completing this Onboarding Questionnaire for...",
        responses:[
            "My entire organization (i.e., Company ABC)",
            "A specific location/region (i.e., Company ABC – Northwest Region)",
            "A specific site (i.e., Company ABC – Chicago Warehouse)",
            "A specific department (i.e., Company ABC – Sales Department)",
            "Other (please describe below)"
        ],
        uniqueInput: true,
    },
    {
        ID:4,
        type: 'fillForm',
        title:"Please enter the following below:",
        responses:{
            q1:"Organization Name:",
            q2:"Specific location/region, site, or department name, if applicable:",
            q3:"First Name:",
            q4:"Last Name:",
            q5:"Email:",
        },
        uniqueInput:true,

    },
    {
        ID:5,
        type:"radio",
        title:"Which of the following best describes your job function?",
        responses:[
            "Accounting",
            "Allied Health Professional/ Healthcare",
            "C-Suite/Executive Leadership",
            "Employee Benefits",
            "Environmental, Health & Safety",
            "Ergonomics/ Human Factors",
            "Finance",
            "Human Resources (HR)",
            "Manager/ director (not function specific)",
            "Marketing",
            "Research & Development",
            "Risk Control",
            "Risk Management",
            "Safety Compliance Officer",
            "Safety Scientist/ Engineer",
            "Safety Supervisor",
            "Sales",
            "Senior Leadership",
            "Staff Training and Development",
            "Supervisor (not function specific)",
            "Other describe below"
        ],
        uniqueInput:true,
    },
    {
        ID:6,
        type:"radio",
        title:"What is your organization's primary industry?",
        responses:[
            "Accommodation and Food Services",
            "Administrative and Support and Waste Management and Remediation Services",
            "Agriculture, Forestry, Fishing and Hunting",
            "Arts, Entertainment, and Recreation",
            "Construction",
            "Educational Services",
            "Finance and insurance",
            "Health Care and Social Assistance",
            "Information",
            "Management of Companies and Enterprises",
            "Manufacturing",
            "Mining",
            "Other Services (except Public Administration)",
            "Professional, Scientific, and Technical Services",
            "Public Administration",
            "Real Estate Rental and Leasing",
            "Retail Trade",
            "Transportation and Warehousing",
            "Utilities",
            "Wholesale Trade",
            "Other - not listed above, describe below"
        ],
        uniqueInput:true,
    },
    {
        ID:7,
        type:"radio",
        title:"Which sub-sector of manufacturing are you a part of?",
        responses:[
            "Apparel Manufacturing", 
            "Beverage and Tobacco Product Manufacturing",
            "Chemical Manufacturing",
            "Computer and Electronic Product Manufacturing",
            "Electrical Equipment, Appliance, and Component Manufacturing",
            "Fabricated Metal Product Manufacturing",
            "Food Manufacturing",
            "Furniture and Related Product Manufacturing",
            "Leather and Allied Product Manufacturing",
            "Machinery Manufacturing",
            "Miscellaneous Manufacturing",
            "Nonmetallic Mineral Product Manufacturing",
            "Paper Manufacturing",
            "Petroleum and Coal Products Manufacturing",
            "Plastics and Rubber Products Manufacturing",
            "Primary Metal Manufacturing",
            "Printing and Related Support Activities",
            "Textile Mills",
            "Textile Product Mills",
            'Transportation Equipment Manufacturing',
            "Wood Product Manufacturing",
        ],
        uniqueInput:false,

    },
    {
        ID:8,
        type:"radio",
        title:"Which sub-sector of construction are you a part of?",
        responses:[
            "Construction of Buildings",
            "Heavy and Civil Engineering Construction",
            "Specialty Trade Contractors",
        ],
        uniqueInput:false,

    },
    {
        ID:9,
        type:"radio",
        title:"Which sub-sector of utilities are you a part of?",
        responses:[
            "Electric Power Generation, Transmission and Distribution",
            "Natural Gas Distribution",
            "Water, Sewage, and Other Systems",
        ],
        uniqueInput:false,

    },
    {
        ID:10,
        type:"radio",
        title:["Which of the following ranges best reflect the number of employees that work for","?"],
        responses:[
            "1 - 10 employees",
            "11 - 50 employees",
            "51 - 100 employees",
            "101 - 250 employees",
            "251 - 500 employees",
            "501 - 1,000 employees",
            "1,001 - 5,000 employees",
            "5,001 - 10,000 employees",
            "10,001 - 100,000 employees",
            "100,001 - 1,000,000 employees",
            "> 1,000,001 employees",
        ],
        uniqueInput:false,
        usesQ4:true,

    },
    {
        ID:11,
        type:"matrix",
        title:["Does ","have a..."],
        responses:{
            questions:{ 
                q1:{
                    id:0,
                    q:"Traditional ergonomics program?",
                    a:[
                        "Yes",
                        "No",
                        "In Development",
                    ],
                },
                q2:{
                    id:1,
                    q:"MSD prevention program (i.e., traditional ergonomics plus additional tools and information for MSD prevention)?",
                    a:[
                        "Yes",
                        "No",
                        "In Development",
                    ]
                }

            },
            options: [
                "Yes",
                "No",
                "In Development",
            ]
        },
        uniqueInput:false,
        usesQ4:true,

    },
    {
        ID:12,
        type:"radio",
        title:"To what degree does new hire training emphasize the identification of work-related musculoskeletal disorder risk factors?",
        responses:[
            "Included a great deal",
            "Included somewhat",
            "Included a little",
            "Not included",
        ],
        uniqueInput:false,
        usesQ4:false,

    },
    {
        ID:13,
        type:"radio",
        title:"To what degree are ergonomics included in safety and health assessments, and used to drive continuous change?",
        responses:[
            "A great deal (such as, Gemba walks or huddles; and daily rounding by safety or ergo champions to identify risk factors, prioritize risks, perform assessments, and develop mitigation strategies as part of the continuous improvement process)",
            "Often (such as, once a week or month collect data on ergonomic injuries, perform risk assessments, and review strategies as part of the reports discussed at safety committee meetings)",
            "Somewhat (such as, identify ergonomic risks, but have less emphasis on assessment or mitigation of risks, report once or twice a year as part of the safety and health risk assessments)",
            "Little (such as, identify ergonomic risks, but do not prioritize risks for assessments or mitigation strategies)",
            "Never",
        ],
        uniqueInput:false,
        usesQ4:false,

    },
    {
        ID:14,
        type:"checkAll",
        title:["Which of the following MSD reduction initiatives has","implemented?"],
        responses:[
            "MSD risk factor identification and prioritization process",
            "Workplace redesign",
            "Job/task redesign",
            "Improved work practices",
            "Prevention through design ergonomics programs (i.e., programs designed to prevent the introduction of new MSD risk factors into operations that impact workers)",
            "Early symptom intervention",
            "Industrial athlete & work readiness programs (i.e., programs that take approaches from the sports industry and apply them to industrial workers)",
            "Work hardening (i.e., an individualized program designed to help workers return to their pre-injury work level)",
            "Job/work conditioning (i.e., a specific, functional program designed to help injured workers return to work)",
            "Job rotation",
            "Use allied health professionals (such as, physical therapist, athletic trainers, massage therapist)",
            "Emerging technologies (such as, exoskeletons, wearables, artificial intelligence, machine learning)",
            "Other(s), describe below",//12
            "My organization has implemented all of the above MSD reduction initiatives",
            "My organization has not implemented any MSD reduction initiatives"
        ],
        uniqueInput:true,
        usesQ4:true,
    },
    {
        ID:15,
        type:"shortAnswer",
        title:"Please describe the emerging technologies utilized (such as, exoskeletons).",
        responses:[""],
        uniqueInput:true,

    },
    {
        ID:16,
        type:"checkAll",
        title:"How frequently are ergonomic evaluations performed? ",
        responses:[
            "Daily",
            "Weekly",
            "Monthly",
            "Annually",
            "Ad hoc/just before an external audit",
            "Whenever an employee need arises",
            "Whenever an injury occurs",
            "Other, please describe below:",//7
            "We do not conduct ergonomic evaluations"
        ],
        uniqueInput:true,

    },
    {
        ID:17,
        type:"matrix",
        title:"How frequently are the following employees engaged with MSD and injury prevention?",
        responses:{
            questions:{ 
                q1: {id:0,q: "Workers",a:[
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                'Never',
               "N/A or Unsure",
            ]},
                q2: {id:1,q:"Frontline supervisors",a:[
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                'Never',
               "N/A or Unsure",
            ]},
                q3:{id:2,q:"Mid-level managers",a:[
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                'Never',
               "N/A or Unsure",
            ]},
                q4:{id:3,q:"C-suite executives",a:[
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                'Never',
               "N/A or Unsure",
            ]},
            },
            options:[
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                'Never',
               "N/A or Unsure",
            ]
        },
        uniqueInput:false,

    },
    {
        ID:18,
        type:"radio",
        title:"To the best of your knowledge, how often are workers consulted regarding changes in tools, equipment, and job processes?",
        responses:[
            "Always",
            "Often",
            "Sometimes",
            "Rarely",
            "Never",
            "Unsure",
        ],
        uniqueInput:false,

    },
    {
        ID:19,
        type:"matrix",
        title:"Please share the most common frequency the following employees receive information regarding MSD and injury prevention (such as, through toolbox talks, safety huddles, all-staff meetings).",
        responses:{
            questions: {
                q1:{id:0,q:"Full-time employees",a:[
                "Onboarding Only",
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                "Never",
                "N/A or Unsure",
            ]},
                q2:{id:1,q:"Part-time employees",a:[
                "Onboarding Only",
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                "Never",
                "N/A or Unsure",
            ]},
                q3:{id:2,q:"Temporary employees",a:[
                "Onboarding Only",
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                "Never",
                "N/A or Unsure",
            ]},
                q4:{id:3,q:"Contractors",a:[
                "Onboarding Only",
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                "Never",
                "N/A or Unsure",
            ]},
                q5:{id:4,q:"PRN/as-needed employees",a:[
                "Onboarding Only",
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                "Never",
                "N/A or Unsure",
            ]}
            },
            options :[
                "Onboarding Only",
                "Daily",
                "Weekly",
                "Monthly",
                "Quarterly",
                "Annually",
                "Never",
                "N/A or Unsure",
            ]
        },
        uniqueInput:false,

    },
    {
        ID:20,
        type:"radio",
        title:["Does","share injury-related prevention resources with other organizations?"],
        responses:[
            "Yes",
            "No",
        ],
        uniqueInput:false,
        usesQ4:true,

    },
    {
        ID:21,
        type:"radio",
        title:["Does", "keep track of the rate of MSDs?"],
        responses:[
            "Yes, we track and are willing to share",
            "Yes, we track, but are not willing to share",
            "No, we don't track",
            "Unsure if we track",
        ],
        uniqueInput:false,
        usesQ4:true,

    },
    
    {
        ID:22,
        type:"shortAnswer",
        title:"If you are comfortable, please share any information about innovative strategies you have used to help prevent MSDs. Additionally, please use this space to share anything else!",
        responses:[""],
        uniqueInput:true,

    },
    {
        ID:23,
        type:"conclusion",
        title:"Thank you for taking the time to complete the Onboarding Questionnaire!",
        responses:["Click below to submit your survey."],
        uniqueInput:false,

    },
]